var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 600,
    viewBox: "0 0 655 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "hex"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 173.2,55 173.2,145 100,190 26.8,145 26.8,55",
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 85,
    y: 35
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 232,
    y: 35
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 379,
    y: 35
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 10,
    y: 170
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 157,
    y: 170
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 305,
    y: 170
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 452,
    y: 170
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 85,
    y: 305
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 232,
    y: 305
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 379,
    y: 305
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutIsland);
export default __webpack_public_path__ + "static/media/layout-island.5d09ee1121f2cae49801bdd3d2640120.svg";
export { ForwardRef as ReactComponent };